import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import MainLayout from "../../Layout/MainLayout";
import { BackButtonNew } from "../../Assets/svg";
import "./style.css";
import { Link } from "react-router-dom";
import { userLogout } from "../../Store/Slices/APIs";
import Common from "../../Util/common";
import { setClearAndStopMixerTrayTrack } from "../../Store/Slices/MyMixerSlice";
import { formatTime, getMediaTypeTitle, getSpecificEndPoint, isVideoUrl } from "../../Util/helpers";
import IndividualAudioPlayer from "../../Components/IndividualAudioPlayer";
import { normalizeResponse } from "../../Util/utils";
import { useDispatch } from "react-redux";
import VimeoEmbedVideo from "../../Components/VimeoEmbedVideo";
import { useTranslation } from "react-i18next";
import { translateToSpanish } from "../../Util/translator";

const AudioDetail = () => {

  const { type, id } = useParams();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [data, setData] = useState({});
  // const [data, setData] = useState({});
  const [translatedTitle, setTranslatedTitle] = useState("");
  const [isTranslating, setIsTranslating] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    dispatch(userLogout())
    getDataByApi();
    return () => {
      dispatch(setClearAndStopMixerTrayTrack(false));
    }
  }, [])

  const getDataByApi = async () => {
    try {
      const url = getSpecificEndPoint(type, id);
      const response = await axios.get(url);
      const rawData = response?.data?.data;
      const result = normalizeResponse(rawData);
      if (!response.data.error) {
        setData(result);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const applyTranslation = async () => {
      // Only translate when UI is Spanish
      if (i18n.language !== "es") {
        setTranslatedTitle("");
        setIsTranslating(false);
        return;
      }

      if (!data || !data.title) return;

      setIsTranslating(true);

      try {
        const result = await translateToSpanish(data.title);
        if (result.success && result.translatedText) {
          setTranslatedTitle(result.translatedText);
        }
      } catch (error) {
        console.error("AudioDetail translation failed:", error);
      } finally {
        setIsTranslating(false);
      }
    };

    applyTranslation();
  }, [i18n.language, data]);
console.log("individualPlayer", t("player.individualPlayer"))
  return (
    <MainLayout>

      <div className="go-back rotate">
        <Link to={`/${type == Common.RELAXATION ? Common.RELAXREST : type}`}><img src={BackButtonNew} className="mw-100 w-22" /> </Link>
      </div>

      <div className="audio-detail-page my-3 my-sm-4">
        {
          !isLoading && (
            <div className="box-wrapper">
              {isVideoUrl(data?.video_url) ? (
                <VimeoEmbedVideo embedHtml={data?.video_url} />
              ) : (
                <div className={`image-thumbnail ${isImageLoading ? "d-none" : ""}`}>
                  <img
                    src={data.image}
                    className="img-fluid w-100 rounded-4"
                    onLoad={() => setIsImageLoading(false)}
                  />
                </div>
              )}

              <div className="content text-center px-3">
                <h6 className="text-white text-capitalize mt-4 " >{(() => {
                  const typeMap = {
                    'relaxation': t("player.relaxation"),
                    'articles': t("nav.avArticles"),
                    'stories': t("player.stories"),
                    'sounds': t("player.soundsAndMusic")
                  };
                  return typeMap[data?.type] || getMediaTypeTitle(data?.type);
                })()}</h6>
                {isTranslating ? (
                  <div className="d-flex justify-content-center my-3 my-sm-4">
                    <div className="spinner-border text-light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <h3 className="text-white my-3 my-sm-4 px-sm-4">{translatedTitle || data.title}</h3>
                )}
                {isVideoUrl(data?.video_url) ? '' : <h5 className="text-white mb-0" style={{ letterSpacing: '0.05em' }}>{t("player.duration")}: {formatTime(data.duration)} {t("player.min")}</h5>}
                {isVideoUrl(data?.video_url) && <p className="text-white mb-2 fs-6" dangerouslySetInnerHTML={{ __html: data?.video_description }} />}
                {!isVideoUrl(data?.video_url) && <IndividualAudioPlayer url={data?.audio} />}
                {isVideoUrl(data?.video_url) ? '' : <h5 className="mt-5" style={{ marginTop: 60 }}>{t("player.individualPlayer")}</h5>}
                <div className="d-none d-sm-block" style={{ height: 60 }}></div>
              </div>
            </div>
          )
        }
      </div>

    </MainLayout >
  );
};

export default AudioDetail;